import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppMeta } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useGetBranchTallyUploadQuery, useUpdateBranchTallyUploadMutation } from "store/services/branchTallyUploadApi";
import BranchTallyUploadForm from "../BranchTallyUploadComponents/BranchTallyUploadForm";

const BranchTallyUploadEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: branchTallyUploadDetail, isLoading: loadingBranchTallyUpload, error } = useGetBranchTallyUploadQuery(id);
  const [updateBranchTallyUpload, { isLoading: updatingBranchTallyUpload }] = useUpdateBranchTallyUploadMutation();
  useAppMeta("Edit Branch Tally Upload");
  const breadcrumbs = [
    { title: "Branch Tally Upload", path: "/app/crm/reports/branch-tally-upload/list" },
    { title: "Edit Branch Tally Upload" },
  ];
  const handleUpdateBranchTallyUpload = async (data) => {
    try {
      await updateBranchTallyUpload({ id, ...data }).unwrap();
      toast.success("Branch Tally Upload successfully updated!");
      navigate(`/app/crm/reports/branch-tally-upload/${id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? err?.message ?? "Couldn't update Branch Tally Upload!");
    }
  };
  return <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={loadingBranchTallyUpload || updatingBranchTallyUpload}><BreadcrumbLayout.Error error={error} /><BreadcrumbLayout.Paper><BranchTallyUploadForm isBusy={loadingBranchTallyUpload || updatingBranchTallyUpload} branchTallyUploadDetail={branchTallyUploadDetail} onSubmit={handleUpdateBranchTallyUpload} /></BreadcrumbLayout.Paper></BreadcrumbLayout>;
};
export default BranchTallyUploadEditScreen;
